export function formatMoney(amount: number, currency: string = 'ZAR'): string {
    let val = 0
    if (!Number.isNaN(amount)) {
        val = amount;
    }
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(val);
  }